export function hasTravelSummaryDetails(
  travelSummary?: Content.Properties.TravelSummary,
): travelSummary is Content.Properties.TravelSummary & {
  travelSummaryDetailsDto: { travelPlan: object };
} {
  return !!travelSummary?.travelSummaryDetailsDto?.travelPlan;
}
